// A dialog whose content the view supplies (the recruiter pickers). Give the root
// x-data="modal('someId')" and open or close it from anywhere with
// admin.openModal('someId') / admin.closeModal('someId').
export default (id) => ({
  open: false,

  init() {
    window.addEventListener('modal:open', (event) => {
      if (event.detail === id) this.open = true;
    });
    window.addEventListener('modal:close', (event) => {
      if (event.detail === id) this.open = false;
    });
  },

  close() {
    this.open = false;
  },
});

export const openModal = (id) => window.dispatchEvent(new CustomEvent('modal:open', { detail: id }));
export const closeModal = (id) => window.dispatchEvent(new CustomEvent('modal:close', { detail: id }));
